// usePersistedNotifications.js
// Permanent-until-dismissed notifications per row — separate from the transient
// row.notifications array (App.js/MessageHelpers.js) that drives the 3s flash.

import { useCallback, useEffect, useRef, useState } from "react";

export function usePersistedNotifications(rows) {
  const [persistedByRow, setPersistedByRow] = useState({});
  const seenIds = useRef(new Set());

  useEffect(() => {
    const newlySeen = [];
    rows.forEach((row) => {
      (row.notifications || []).forEach((notification) => {
        if (!notification?.id || seenIds.current.has(notification.id)) return;
        seenIds.current.add(notification.id);
        newlySeen.push({ rowId: row.id, notification });
      });
    });

    if (newlySeen.length > 0) {
      setPersistedByRow((prev) => {
        const next = { ...prev };
        newlySeen.forEach(({ rowId, notification }) => {
          next[rowId] = [...(next[rowId] || []), notification];
        });
        return next;
      });
    }
  }, [rows]);

  const dismiss = useCallback((rowId) => {
    setPersistedByRow((prev) => {
      if (!prev[rowId]?.length) return prev;
      const next = { ...prev };
      delete next[rowId];
      return next;
    });
  }, []);

  return { persistedByRow, dismiss };
}
